<ng-container>
<div class="condition-group" *ngIf="!!group">
	<div class="group-type flex row align-center mb-6">
		<mat-icon class="mr-3" [class.collapse]="collapse" (click)="toggleCollapse()">chevron_right</mat-icon>
		<label i18n="Visibility Condition Group Operator Label@@VisibilityConditionGroupOperatorLabel">Group Operator:</label>
		<app-select-input
			[currentValue]="group.type"
			[optionValueKey]="'value'"
			[options]="groupOperatorOptions"
			(valueChange)="updateGroupType($event)"
		></app-select-input>
		<div *ngIf="collapse">{{ countConditionsAndGroups(group) }}</div>
		<mat-icon (click)="removeGroup()" class="cursor-pointer">close</mat-icon>
	</div>

	<!-- Loop through all conditions/groups in the current group -->
	<div
		class="main-content"
		[class.collapse]="collapse"
		*ngFor="let conditionOrGroup of group.conditions; let i = index"
	>
		<ng-container *ngIf="isCondition(conditionOrGroup); else groupBlock">
			<!-- It's a condition -->
			<div class="condition">
				<app-text-input
					class="mt-3 block"
					[currentValue]="conditionOrGroup.path"
					[objectData]="mergeTagState"
					(valueChange)="update('path', i, $event)"
					label="Path"
					i18n-label="Visibility Condition Path Input Label@@VisibilityConditionPathInputLabel"
				></app-text-input>
				<app-select-input
					class="mt-3"
					label="Condition"
					i18n-label="Visibility Condition Condition Input Label@@VisibilityConditionConditionInputLabel"
					[currentValue]="conditionOrGroup.relation"
					[optionValueKey]="'value'"
					[options]="relationOptions"
					(valueChange)="update('relation', i, $event)"
				></app-select-input>
				<app-text-input
					*ngIf="conditionOrGroup.value != undefined"
					class="mt-3 block"
					[currentValue]="conditionOrGroup.value"
					(valueChange)="update('value', i, $event)"
					label="Value"
					i18n-label="Visibility Condition Value Input Label@@VisibilityConditionValueInputLabel"
				></app-text-input>
				<mat-icon (click)="removeConditionOrGroup(group, i)" class="cursor-pointer"
					>close</mat-icon
				>
			</div>
		</ng-container>

		<!-- It's a nested group -->
		<ng-template #groupBlock>
			<app-recursive-condition-group [group]="conditionOrGroup" [parentGroup]="group" (onChange)="onChange.emit()"></app-recursive-condition-group>
		</ng-template>

		<div class="buttons mt-6 pb-3" *ngIf="isLastCondition(group, i)">
			<button mat-button (click)="addCondition(group, i)" i18n="Visibility Condition Add Condition Label@@VisibilityConditionAddConditionLabel">+ Add Condition</button>
			<button mat-button (click)="addGroup(group, i)" i18n="Visibility Condition Add Group Label@@VisibilityConditionAddGroupLabel">+ Add Group</button>
		</div>
	</div>

	<div class="buttons mt-6 pb-3" *ngIf="(group?.conditions?.length || 0) == 0">
		<button mat-button (click)="addCondition(group, 0)" i18n="Visibility Condition Add Condition Label@@VisibilityConditionAddConditionLabel">+ Add Condition</button>
		<button mat-button (click)="addGroup(group, 0)" i18n="Visibility Condition Add Group Label@@VisibilityConditionAddGroupLabel">+ Add Group</button>
	</div>

	<!-- Buttons to add a new condition or group -->
</div>

	<div class="buttons mt-6 pb-3" *ngIf="!group">
		<button mat-button (click)="addRootGroup()" i18n="Visibility Condition Add Group Label@@VisibilityConditionAddGroupLabel">+ Add Group</button>
	</div>
</ng-container>
